import { Injectable } from '@angular/core';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { stocksFeatureStoreKey } from '../feature/stocks.feature';
import { InitStocksState } from '../state/stocks.state';

export const getInitStockState = createFeatureSelector<InitStocksState>(
  stocksFeatureStoreKey,
);

export const getExpectedStocks = createSelector(
  getInitStockState,
  (state) => state.expectedStocks,
);

export const getShowStocksAveragePrice = createSelector(
  getInitStockState,
  (state) => state.showStocksAveragePrice,
);

export const getReckonExpectedStocks = createSelector(
  getInitStockState,
  (state) => {
    return state.reckonExpectedStocks ?? [];
  },
);

@Injectable({
  providedIn: 'root',
})
export class StocksSelectors {
  getShowStocksAveragePrice$ = this.store.select(getShowStocksAveragePrice);
  getReckonExpectedStocks$ = this.store.select(getReckonExpectedStocks);
  getExpectedStocks$ = this.store.select(getExpectedStocks);

  constructor(private store: Store<InitStocksState>) {}
}
